import { useToast,Spacer,Text,Tooltip,Avatar, useDisclosure ,Input, Box,Flex, Button, Badge, PopoverContent,PopoverHeader, Popover, PopoverTrigger,PopoverBody, PopoverCloseButton} from "@chakra-ui/react";
import { loggedOper as lp } from "../../util/grunt";
import {useState, useEffect} from 'react';
import {updatePwd2} from '../../util/apiCalls'
import {getEnvironment} from '../../util/apiUtil';

const OperAvatarInfo = ({onLogOut}) => {
    const { onOpen, onClose, isOpen } = useDisclosure()
    const [pass,setPass]=useState(false);
    const [oldpwd,setOldPwd]=useState("");
    const [newpwd,setNewPwd]=useState("");
    const [env,setEnv]=useState("");
    
    const [apiVersion,setApiVersion]=useState("");
    const toast=useToast();
    useEffect(() => {
        const ClearPwdValues=()=>{
            setOldPwd("");
            setNewPwd("");
        }
        ClearPwdValues();
    }, [pass]);

    useEffect(() => {
      const getEnv=async()=>{
        const res=await getEnvironment();
        if (res.status===200) {
            setEnv(res.res.environment);
            
            setApiVersion(res.res.api_version);
        } else {
            setEnv("GREŠKA KOD UČITAVANJA PODATAKA OKOLINE");
        }
      }
    getEnv();
      
    }, [])
    
    

    const PassIzmjena=()=>{
        if (pass===true) {
            return (
            <Flex direction={'column'} gap={'1'}>
                <label htmlFor={'oldpwd'} fontSize='1em'>Stara lozinka</label>
                <Input focusBorderColor='grunt2.400' variant={'filled'} id={'oldpwd'} type={'password'} maxLength={20} size={'xs'} mb={2} onChange={onChange} value={oldpwd} autoFocus></Input>
                
                <label htmlFor='newpwd' fontSize='1em'>Nova lozinka</label>
                <Input focusBorderColor='grunt2.400' variant={'filled'} id={'newpwd'} type={'password'} maxLength={20} size={'xs'} mb={3} onChange={onChange} value={newpwd}></Input>
            </Flex>
            )
        }
        else {
            return (<></>)
        }
    }

    const Uloga=()=>{
        if (lp.uloga==="a") {
            return (<Badge rounded={'md'} colorScheme='grunt2' variant={'outline'} size={'xs'}>Administrator</Badge>)
        } else if (lp.uloga==="w") {
            return (<Badge rounded={'md'} colorScheme='grunt2' variant={'outline'} size={'xs'}>Čitanje/pisanje</Badge>)
        } else if (lp.uloga==="v") {
            return (<Badge rounded={'md'} colorScheme='grunt2' variant={'outline'} size={'xs'}>Veterinar</Badge>)
        }
        
        else {
            return (<Badge rounded={'md'} colorScheme='grunt2' variant={'outline'} size={'xs'}>Čitanje</Badge>)
        }
        
    }

    const Spremi=()=>{
        if (pass===true) {
            return (
                <Button colorScheme={'grunt2'} size={'xs'} onClick={SavePwd}>Spremi</Button>
            )
        }
        else {
            return (<></>)
        }
    }

    const PromjenaLozinkeBtn=()=>{
        //<Button colorScheme={'grunt2'} size={'xs'} onClick={ChangePwd}>{pass?"Odustani":"Promjena lozinke"}</Button>
        if (pass===true){
            return (<Button colorScheme={'grunt2'} size={'xs'} onClick={ChangePwd} variant={'outline'}>Odustani</Button>)
                
        } else {
            return (<Button colorScheme={'grunt2'} size={'xs'} onClick={ChangePwd}>Promjena lozinke</Button>)
        }
    }
    

    const Open=()=>{
        setPass(false);
        onOpen();
    }

    const Odjava=()=>{
        lp.odjava();
        onLogOut();
        onClose();
    }

    const ChangePwd=()=>{
        
        //updatePwd2
        setPass(!pass);
    }

    const SavePwd= async()=>{
        let _err=false;
        let _msg="";
        try {
            const res=await updatePwd2(lp.operater_id,oldpwd,newpwd);
            if (res.status==="ok") {
                _msg="Lozinka uspješno promijenjena";
                setPass(!pass);
            } else {
                _err=true;
                _msg="Greška: "+res.status+" - " +res.message;
            }
            toast({
                title:_err?"Greška kod izmjene lozinke":_msg,
                status:_err?"error":"success",
                description:_msg,
                isClosable:true,
                duration:2000,
                position:"top",
            });
        } catch (error) {
                _err=true;
                _msg="Greška: "+error.status+" - " +error.message;
                toast({
                    title:_err?"Greška kod izmjene lozinke":_msg,
                    status:_err?"error":"success",
                    description:_msg,
                    isClosable:true,
                    duration:2000,
                    position:"top",
                });
        }
        
           
        
    }

    const onChange=(e)=>{
        if (e.target.id==="newpwd") {
            setNewPwd(e.target.value);
        }
        else {
            setOldPwd(e.target.value);
        }
    }

    return (
        <>
            <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} placement='left' closeOnBlur={true}>
            <PopoverTrigger>
                <Tooltip label={lp.operater} fontSize={'xs'} placement={'left-start'}>
                    <Avatar name={lp.operater} size='sm' cursor='pointer' onClick={Open}></Avatar>
                </Tooltip>
            </PopoverTrigger>
            <PopoverContent p={3} zIndex={6}>
            <PopoverCloseButton/>
            <PopoverHeader>
                <Box mb={'2px'}>
                    <Text fontWeight={'semibold'} fontSize={'2xs'} color={'grunt2.300'}>{env.toUpperCase()} - {apiVersion} </Text>
                </Box>
                <Flex direction={'row'} mb={4}>
                    <Avatar name={lp.operater} size={'xs'} mr={2}/>
                    <Text fontWeight={'semibold'} mr={2}>{lp.operater}</Text>
                    
                    <Text>{Uloga()}</Text>
                </Flex>
                <Flex direction={'row'}>
                    {PromjenaLozinkeBtn()}
                    <Spacer/>
                    <Button colorScheme={'red'} variant={'outline'} size={'xs'} onClick={Odjava}>Odjava</Button>
                </Flex>
            </PopoverHeader>
              
              <PopoverBody>
                {PassIzmjena()}
                <Flex direction={'row'}>
                    
                    
                    {Spremi()}
                </Flex>
              </PopoverBody>
              
            </PopoverContent>
            </Popover>
        </>
    );
}

export default OperAvatarInfo;
